import { createRouter, RouterProvider } from "@tanstack/react-router"

import { useAuth } from "@/store/auth"
import { withProviders } from "@/components/providers"

import { queryClient } from "./lib/query-client"
import { routeTree } from "./routeTree.gen"

const router = createRouter({
  routeTree: routeTree as Parameters<typeof createRouter>[0]["routeTree"],
  defaultPreload: "intent",
  context: {
    auth: undefined!,
    queryClient,
  },
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

const App = withProviders(() => {
  const auth = useAuth()

  return <RouterProvider router={router} context={{ auth }} />
})

export default App
